<template>
  <div class="tabs">
    <div class="tabs__content">
      <div
        v-for="(item, i) in items"
        :key="i"
        class="tabs__item text-md"
        :class="getClasses(i)"
        v-html="item.title"
        @click.stop="item.enabled === true ? changeTab(i) : ''"
      ></div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Tabs',
  designVersion: '1.0.0',
  props: {
    /**
     * Массив с именами и состояниями табов
     */
    items: {
      type: Array,
      validator(value) {
        return value.length > 0;
      }
    },
    /**
     * Индекс выбранного элемента
     */
    activeItem: {
      type: [String, Number],
      default: 0,
      validator(value) {
        return value >= 0;
      }
    }
  },
  data() {
    return {
      selectedItem: 0,
    };
  },
  watch: {
    activeItem() {
      this.updateActiveItem();
    },
  },
  methods: {
    changeTab(index) {
      this.selectedItem = index;
      this.$emit('changed', index);
    },
    updateActiveItem() {
      if (this.items.length === 0) return;
      if (this.$props.activeItem > this.items.length - 1) {
        this.selectedItem = this.items.length - 1;
        return;
      }
      this.selectedItem = this.$props.activeItem;
    },
    getClasses(index) {
      const classes = [];
      if (this.selectedItem === index && this.items[index].enabled === true) classes.push('tabs__item_active');
      if (this.items[index].enabled === false) classes.push('tabs__item_disabled');
      return classes;
    },
  },
  mounted() {
    this.updateActiveItem();
  },
};
</script>

<style lang="scss" scoped>
  @import './Tabs';
</style>
